import { Link } from '../../../api/contract-notice-dto';
import {
  BaseEntityDTO, BaseObjectDTO, DivisionDTO, DocumentClassDTO,
  LinkedActionsDTO, MasterDataDTO, TaskDTO, WorkDTO, DocumentDTO
} from '../../../api/plyca-dtos';
import { AwardDTO, ContractDTO, ObjectContextDTO } from '../../../api/plyca-dtos-v2';

export class CorrectPeriodDTO {
  correctPeriod: number;
  utCorrectPeriod: MasterDataDTO;
}


export class ReceiptDTO implements BaseEntityDTO {
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
  links: Link[];
  identifier: any;
  task: TaskDTO;
  award: AwardDTO;
  contract: ContractDTO;
  amount: number;
  receiptDate: Date;
  registrationDate: Date;
  executionDate: Date;
  registerNumberContractModificacion: string;
  receiptType: MasterDataDTO;
  action: string;
  defect: string;
  observation: string;
  correctPeriod: CorrectPeriodDTO;
  document: DocumentDTO;
  context?: ObjectContextDTO;
  projectOrganizationalSnapshot?: any;
  previousOrganizationalUnitRegistration: boolean;
}

// TODO ver si hay ue incluirlo en plyca-dtos.ts
export class WorkReceiptDTO implements BaseObjectDTO<string> {
  identifier: string;
  links: Link[];
  context?: ObjectContextDTO;
  receipt: ReceiptDTO;
  reactive: boolean;
  task: TaskDTO;
  availableActions: LinkedActionsDTO;
}